import {
  GET_AREA_LIST,
  GET_DIR_LOCATION_LIST
} from 'fixtures/actions'

let initialState = []

const areaList = (state = initialState, action) => {
  switch (action.type) {
    case GET_AREA_LIST:
      return [...action.payload]
    default:
      return state
  }
}

const dirLocationList = (state = initialState, action) => {
  switch (action.type) {
    case GET_DIR_LOCATION_LIST:
      return [...action.payload]
    default:
      return state
  }
}

export { areaList, dirLocationList }
